import React from 'react';
import { Flex } from '/app/src/component'
import style from './style.css'

class Item extends React.Component
{
    render() {
        let styling = style.resetTextMargin + ' ' + style.item;
        if (this.props.activeItemId === this.props.id) styling += ' ' + style.active;
        return (
            <Flex className={styling}
                vAlignContent='center'
                borderBottom='1px solid #707070'
                width='inherit'
                onClick={ this.props.onClick }>
                <Flex center width='20%' >
                    <p className={style.dataText}> {this.props.companyTicketId || 'Ingen ID'} </p>
                </Flex>
                <Flex center width='20%'>
                    <p className={style.dataText}> {this.props.companyCustomerId || 'Ingen ID'} </p>
                </Flex>
                <Flex center width='20%'>
                    <p className={style.dataText}> {this.props.coworkerName || 'Ej angiven'} </p>
                </Flex>
                <Flex center width='20%'>
                    <p className={style.dataText}> {this.props.created || 'Ej angiven'} </p>
                </Flex>
                <Flex center width='20%'>
                    <p className={style.dataText}> {this.props.resolved || 'Pågående'} </p>
                </Flex>
            </Flex>
        )
    }
}

export default Item



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Search/Ticket/Item/index.js